module.exports = __webpack_public_path__ + "assets/calendar.2726d197.svg";